export default __webpack_public_path__ + "static/media/leaf_selected.30447f75.svg";